import '../../../../bower_components/fastclick/lib/fastclick';
import $ from 'jquery';
window.$ = window.jQuery = $;
require('../../../../node_modules/lazyloadxt/dist/jquery.lazyloadxt');
require('../../../../node_modules/lazyloadxt/dist/jquery.lazyloadxt.video');
require('../../../../node_modules/lazyloadxt/dist/jquery.lazyloadxt.srcset');
import config from './config';
import _ from 'underscore';
import Backbone from 'backbone';
import loadThirdPartyJs from './utils/third_party_util';
import ads from './services/admanager';
import legacyGlobals from './utils/legacy-globals';
import cookieUtil from 'js-cookie';
Backbone.$ = $;
Backbone._ = _;
let bulk = require('bulk-require');
import router from './services/router_service';
bulk(__dirname, [
    './routes/*.js'
]);

// Globals need to happen before document ready
legacyGlobals();
const startApp = () => {
    // initializing lazyload lib with config object. edgeY is the distance from viewport before the call is made to retrieve the asset
    $.extend($.lazyLoadXT, {
        edgeY: 200,
        edgeX: 400
    });

    $(()=> {
        Backbone.history.start({
            root: '/',
            pushState: true,
            silent: false
        });
        router.trigger('route:common');
        ads();

        // @Mezzobit - feel free to move this to your UI :)
        loadThirdPartyJs();
        config.setinitialPageLoad();
    });
};

if (cookieUtil('fc_auth')) {
    config.authCheck().then(() => {
        startApp();
    });
} else {
    startApp();
}
